module.exports = __webpack_public_path__ + "images/price-drops-black-840131b4.svg";